<template>
  <div class="topbar medhop-topbar">
    <NotificationCenter :operational-signals="operationalSignals" />
    <KTQuickUser />
  </div>
</template>

<script>
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import NotificationCenter from "@/view/layout/header/NotificationCenter.vue";
import ApiService from "@/core/services/api.service.js";
import { getdbconfigparams } from "@/core/services/jwt.service.js";

export default {
  name: "KTTopbar",
  components: { KTQuickUser, NotificationCenter },
  data() {
    return {
      metrics: { availableBeds:0, paymentsToday:0, patientsToday:0, appointmentsToday:0, appointmentSubmissions:0, expiredMedicines:0 },
      dbconfigparams: getdbconfigparams()
    };
  },
  computed: {
    operationalSignals() {
      return [
        { key:"expired-medicines", count:this.metrics.expiredMedicines, severity:"critical", category:"pharmacy", title:`${this.metrics.expiredMedicines} obat kedaluwarsa`, message:"Pisahkan dari stok aktif dan lakukan tindak lanjut farmasi.", context:"Perlu tindakan segera", action_label:"Buka farmasi", action_url:"/medicine/expiration-warning", icon:"fas fa-capsules" },
        { key:"appointment-submissions", count:this.metrics.appointmentSubmissions, severity:"action", category:"service", title:`${this.metrics.appointmentSubmissions} pengajuan appointment`, message:"Pengajuan pasien menunggu konfirmasi jadwal klinik.", context:"Hari ini", action_label:"Tinjau pengajuan", action_url:"/appointment/list/1", icon:"fas fa-calendar-check" },
        { key:"appointments-today", count:this.metrics.appointmentsToday, severity:"info", category:"service", title:`${this.metrics.appointmentsToday} appointment hari ini`, message:"Pantau kedatangan dan kesiapan layanan pasien.", context:"Hari ini", action_label:"Buka appointment", action_url:"/appointment/todays", icon:"far fa-calendar-alt" },
        { key:"payments-today", count:this.metrics.paymentsToday, severity:"info", category:"billing", title:`${this.metrics.paymentsToday} pembayaran tercatat`, message:"Transaksi pembayaran yang terdaftar hari ini.", context:"Hari ini", action_label:"Buka billing", action_url:"/payment/list", icon:"fas fa-receipt" },
        { key:"patients-today", count:this.metrics.patientsToday, severity:"info", category:"service", title:`${this.metrics.patientsToday} pasien baru`, message:"Pasien yang didaftarkan pada hari ini.", context:"Hari ini", action_label:"Buka pasien", action_url:"/patient/list", icon:"fas fa-user-plus" },
        { key:"available-beds", count:this.metrics.availableBeds, severity:"info", category:"service", title:`${this.metrics.availableBeds} bed tersedia`, message:"Kapasitas rawat inap yang siap digunakan.", context:"Status saat ini", action_label:"Lihat bed", action_url:"/beds/list", icon:"fas fa-bed" }
      ];
    }
  },
  mounted() {
    this.refreshMetrics();
    ["UpdateNewPayment","UpdateNewAvailableBed","UpdateNewPatient","UpdateNewAppointment"].forEach(event => this.$root.$on(event, this.refreshMetrics));
  },
  beforeDestroy() {
    ["UpdateNewPayment","UpdateNewAvailableBed","UpdateNewPatient","UpdateNewAppointment"].forEach(event => this.$root.$off(event, this.refreshMetrics));
  },
  methods: {
    endpoint(name) { return ApiService.get(name, `?${this.dbconfigparams}`); },
    numberFrom(response) { const value=response&&response.data; return Number(value&&value.data!==undefined?value.data:value)||0; },
    async refreshMetrics() {
      const requests=[["availableBeds","total-available-beds"],["paymentsToday","total-new-payments"],["patientsToday","total-new-patients"],["appointmentsToday","total-appointments-today"],["appointmentSubmissions","total-submission"],["expiredMedicines","total-medicine-expireds"]];
      await Promise.all(requests.map(async ([key,endpoint])=>{try{this.$set(this.metrics,key,this.numberFrom(await this.endpoint(endpoint)));}catch(_){}}));
    }
  }
};
</script>

<style lang="scss">
.medhop-topbar{display:flex;align-items:center;gap:4px}.medhop-topbar .dropdown-toggle::after{display:none!important}
</style>
